import { SubmittedDocument } from '@data-access/documents/types';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  updateEntity,
  withEntities,
} from '@ngrx/signals/entities';

const _submittedDocumentsEntityConfig = () =>
  entityConfig({
    collection: '_submittedDocuments',
    entity: type<SubmittedDocument>(),
    selectId: (entity) =>
      `${entity.id}${entity.task_title ? `-${entity.task_title}` : ''}`,
  });

export const withSubmittedDocumentsEntities = () => {
  return signalStoreFeature(
    withEntities(_submittedDocumentsEntityConfig()),
    withMethods(({ ...store }) => ({
      loadSubmittedDocuments: (data: SubmittedDocument[]) => {
        return patchState(
          store,
          setAllEntities(data, _submittedDocumentsEntityConfig()),
        );
      },

      updateSubmittedDocument: (
        id: string,
        changes: Partial<SubmittedDocument>,
      ) =>
        patchState(
          store,
          updateEntity({ id, changes }, _submittedDocumentsEntityConfig()),
        ),
    })),
  );
};
